export default "__VITE_ASSET__DjvkCTYK__"